import React, { memo } from 'react';
import styled from 'styled-components';
import Checkbox from './Checkbox';

const CheckFieldWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
  .label {
    flex: 1;
    margin-left: 1.2rem;
    line-height: 16px;
    font-size: ${(props) => (props.style.fontSize ? props.style.fontSize : "1.2rem" || "1.2rem")};
    margin-top: -0.2rem;
    color: ${(props) => (props.checked ? 'var(--color-black)' : 'var(--color-battleship_grey)')};
  }
`;
const CheckField = memo(({ checked, label, ...props }) => {
  return (
    <CheckFieldWrapper checked={checked} {...props}>
      <Checkbox checked={checked} />
      <p className="label">{label}</p>
    </CheckFieldWrapper>
  );
});

export default CheckField;
